module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float"
  }, [_c('div', {
    staticClass: "my-float"
  }, [_c('plus-icon', {
    attrs: {
      "width": "32",
      "height": "32",
      "color": "white"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b86ccc4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FloatButton.vue
// module id = 1193
// module chunks = 21